import { render } from "./VisualCompartment.vue?vue&type=template&id=ca90017c&scoped=true"
import script from "./VisualCompartment.vue?vue&type=script&lang=js"
export * from "./VisualCompartment.vue?vue&type=script&lang=js"

import "./VisualCompartment.vue?vue&type=style&index=0&id=ca90017c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca90017c"]])

export default __exports__